import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';

import { Name } from '../../../app/spaces/Tooltips/Elements/Name';
import { RelatedEntity } from '../../../app/spaces/Tooltips/Elements/RelatedEntity';
import { Tags } from '../../../app/spaces/Tooltips/Elements/Tags';
import { Timestamp } from '../../../app/spaces/Tooltips/Elements/Timestamp';
import { Tooltip } from '../../../app/spaces/Tooltips/Elements/Tooltip';
import { User } from '../../../app/spaces/Tooltips/Elements/User';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from '../../../app/spaces/Tooltips/TooltipHelper';
import { Messages } from '../../../codegen/Localize';
import { IPublishedConnectionInfo } from '../../models/IPublishedConnectionInfo';

export function PublishedConnectionTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const publishedConnectionInfo = content as IPublishedConnectionInfo;
  const projectLink = getProjectLink(publishedConnectionInfo.project, urls);
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField
        markup={props.content.description}
        testId={TooltipDescriptionTestId}
        extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} />}
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
